// src/app/_landing/components/AchievementBadgesSection.tsx
import { Shield, Users } from "lucide-react";

export const AchievementBadgesSection = () => {
  return (
    <section className="w-full px-4 lg:px-8 py-4">
      <div className="max-w-6xl mx-auto">
        <div 
          className="p-8 rounded-2xl border"
          style={{ 
            backgroundColor: '#0C1113',
            borderColor: '#374151'
          }}
        >
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-white">Achievement Badges</h2>
            <button 
              className="px-4 py-2 rounded-lg border text-white hover:bg-gray-700 transition-colors"
              style={{ 
                backgroundColor: '#0C1113',
                borderColor: '#99A1AF'
              }}
            >
              View All
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Early Adopter Badge */}
            <div 
              className="rounded-xl p-6 border"
              style={{ 
                backgroundColor: 'rgba(96, 255, 138, 0.05)',
                borderColor: '#60FF8A'
              }}
            >
              <div className="flex items-start space-x-4">
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(96, 255, 138, 0.1)' }}
                >
                  <Shield className="w-6 h-6" style={{ color: '#60FF8A' }} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-white mb-2">Early Adopter</h3>
                  <p className="mb-3" style={{ color: '#99A1AF' }}>Joined in the first 1000 users</p>
                  <div className="text-sm" style={{ color: '#60FF8A' }}>2x multiplier</div>
                </div>
              </div>
            </div>

            {/* Community Builder Badge */}
            <div 
              className="rounded-xl p-6 border"
              style={{ 
                backgroundColor: 'rgba(99, 161, 175, 0.05)',
                borderColor: '#374151'
              }}
            >
              <div className="flex items-start space-x-4">
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(99, 161, 175, 0.1)' }}
                >
                  <Users className="w-6 h-6" style={{ color: '#99A1AF' }} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-white mb-2">Community Builder</h3>
                  <p className="mb-3" style={{ color: '#99A1AF' }}>Active community participant</p>
                  <div className="text-sm" style={{ color: '#60FF8A' }}>2.5x multiplier</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
